import femaleTheme from "./femaleTheme"
import maleTheme from "./maleTheme"
import defaultTheme from "./defaultTheme"

export default { femaleTheme, maleTheme, defaultTheme }